@if (combinedItems(); as combinedItems) {
  @if (combinedItems && combinedItems.length > 0) {
    <div [class.table-style]="tableStyle()"
         class="work-ui-interactions-timeline">
      @if (accordionView()) {
        @if (combinedItems.length > 1) {
          <work-ui-accordion-item #accordion
                                  [headerIconSpaceBetween]="false"
                                  [headerNoHoverEffect]="true"
                                  [hideIcon]="true"
                                  [noPadding]="true"
                                  [withBorder]="false">
            <div accordion-header>
              @let combinedItem = combinedItems[0];
              @if (combinedItem.interaction) {
                <work-ui-timeline-interaction-item [interaction]="combinedItem.interaction"
                                                   [tableStyle]="tableStyle()" />
              } @else if (combinedItem.ticketStatusChange) {
                <work-ui-timeline-ticket-status-change-item [tableStyle]="tableStyle()"
                                                            [ticketStatusChange]="combinedItem.ticketStatusChange" />
              } @else if (combinedItem.ticketUserChange) {
                <work-ui-timeline-ticket-user-change-item [tableStyle]="tableStyle()"
                                                          [ticketUserChange]="combinedItem.ticketUserChange" />
              }
            </div>
            <div accordion-icon class="work-ui-interactions-timeline__show-more">
              <work-ui-button [iconName]="accordion.isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
                              [iconPositionRight]="true"
                              [text]="'+' + (combinedItems.length - 1) + ' ' + ('WEITERE_ANZEIGEN' | translate)"
                              fontWeight="regular"
                              size="small"
                              variant="tertiary" />
            </div>
            <div [ngClass]="{'flex flex-column gap-8': tableStyle()}" accordion-content>
              @for (combinedItem of combinedItems; track combinedItem.id; let i = $index) {
                @if (i > 0) {
                  @if (combinedItem.interaction) {
                    <work-ui-timeline-interaction-item [interaction]="combinedItem.interaction"
                                                       [tableStyle]="tableStyle()" />
                  } @else if (combinedItem.ticketStatusChange) {
                    <work-ui-timeline-ticket-status-change-item [tableStyle]="tableStyle()"
                                                                [ticketStatusChange]="combinedItem.ticketStatusChange" />
                  } @else if (combinedItem.ticketUserChange) {
                    <work-ui-timeline-ticket-user-change-item [tableStyle]="tableStyle()"
                                                              [ticketUserChange]="combinedItem.ticketUserChange" />
                  }
                }
              }
            </div>
          </work-ui-accordion-item>
        } @else {
          @let combinedItem = combinedItems[0];
          @if (combinedItem.interaction) {
            <work-ui-timeline-interaction-item [interaction]="combinedItem.interaction" [tableStyle]="tableStyle()" />
          } @else if (combinedItem.ticketStatusChange) {
            <work-ui-timeline-ticket-status-change-item [tableStyle]="tableStyle()"
                                                        [ticketStatusChange]="combinedItem.ticketStatusChange" />
          } @else if (combinedItem.ticketUserChange) {
            <work-ui-timeline-ticket-user-change-item [tableStyle]="tableStyle()"
                                                      [ticketUserChange]="combinedItem.ticketUserChange" />
          }
        }
      } @else {
        @for (combinedItem of combinedItems; track combinedItem.id; let i = $index) {
          @if (combinedItem.interaction) {
            <work-ui-timeline-interaction-item [interaction]="combinedItem.interaction" [tableStyle]="tableStyle()" />
          } @else if (combinedItem.ticketStatusChange) {
            <work-ui-timeline-ticket-status-change-item [tableStyle]="tableStyle()"
                                                        [ticketStatusChange]="combinedItem.ticketStatusChange" />
          } @else if (combinedItem.ticketUserChange) {
            <work-ui-timeline-ticket-user-change-item [tableStyle]="tableStyle()"
                                                      [ticketUserChange]="combinedItem.ticketUserChange" />
          }
        }
      }
    </div>
  } @else {
    <p class="work-text-color-light">
      {{ 'AKTIVITAET_KEINE' | translate }}
    <p>
  }
}

